import { render, staticRenderFns } from "./bookmark-guide.vue?vue&type=template&id=00065d53"
import script from "./bookmark-guide.vue?vue&type=script&lang=js"
export * from "./bookmark-guide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports